import * as React from "react";
import { cn } from "@/lib/utils";

type SwitchProps = {
	checked: boolean;
	onCheckedChange: (checked: boolean) => void;
	disabled?: boolean;
	className?: string;
	id?: string;
};

export function Switch({ checked, onCheckedChange, disabled, className, id }: SwitchProps) {
	return (
		<button
			id={id}
			type="button"
			role="switch"
			aria-checked={checked}
			disabled={disabled}
			onClick={() => !disabled && onCheckedChange(!checked)}
			className={cn(
				"peer inline-flex h-6 w-11 shrink-0 items-center rounded-full border border-transparent transition-colors",
				"focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-orange-400 focus-visible:ring-offset-2",
				"disabled:cursor-not-allowed disabled:opacity-50",
				checked ? "bg-ink" : "bg-slate-300",
				className,
			)}
		>
			<span
				className={cn(
					"pointer-events-none block h-5 w-5 rounded-full bg-white shadow transition-transform",
					checked ? "translate-x-5" : "translate-x-0",
				)}
			/>
		</button>
	);
}
